// The shell's own palette commands and shortcuts, registered at start-up like a feature's.
import { KeyboardIcon, LanguagesIcon, SunMoonIcon, SwatchBookIcon } from "lucide-react";
import { currentLanguage, setLanguage } from "../../i18n";
import { registerCommand } from "../registry/commands";
import { registerShortcut } from "../registry/shortcuts";
import { setOverlay, toggleOverlay } from "./overlays";
import { toggleTheme } from "./theme";

registerShortcut({
  id: "palette",
  keys: "mod+k",
  labelKey: "shortcuts.palette",
  run: () => toggleOverlay("palette"),
});
registerShortcut({
  id: "shortcuts",
  keys: "?",
  labelKey: "shortcuts.help",
  run: () => setOverlay("shortcuts"),
});

registerCommand({
  id: "theme",
  group: "palette.groups.actions",
  labelKey: "commands.theme",
  icon: SunMoonIcon,
  keywords: ["dark", "light", "sombre", "clair"],
  run: toggleTheme,
});
registerCommand({
  id: "language",
  group: "palette.groups.actions",
  labelKey: "commands.language",
  icon: LanguagesIcon,
  keywords: ["english", "français", "langue"],
  run: () => void setLanguage(currentLanguage() === "fr" ? "en" : "fr"),
});
registerCommand({
  id: "shortcuts",
  group: "palette.groups.actions",
  labelKey: "commands.shortcuts",
  icon: KeyboardIcon,
  keywords: ["keyboard", "clavier"],
  run: () => setOverlay("shortcuts"),
});

if (import.meta.env.DEV) {
  registerCommand({
    id: "dev:ui",
    group: "palette.groups.actions",
    labelKey: "commands.uiGallery",
    icon: SwatchBookIcon,
    to: "/dev/ui",
  });
}
